export default __webpack_public_path__ + "static/media/Contact.9e9a5781.svg";